import { IdCardLanyard } from 'lucide-react';
import { Button } from '@/client/components/ui/button';
import { useClientSwapInfo } from '@/client/components/swap-client-dialog';
import { useCCSwapStore } from '@/client/store/ccSwapStore';
import { CC_BASE_URL } from '@/client/config';

interface CCButtonProps {
  /** Client ID */
  clientID?: string | null;
  /** Event ID suffix (without client prefix) */
  eventID?: string | null;
  /** Client name for swap dialog */
  clientName?: string | null;
  /** Size variant */
  size?: 'sm' | 'default';
}

function buildCCUrl(eventID: string): string {
  return `${CC_BASE_URL}/events/slim?eventID=${eventID}`;
}

export function CCButton({ clientID, eventID, clientName, size = 'sm' }: CCButtonProps) {
  const clientIDStr = clientID || '';
  const { needsSwap } = useClientSwapInfo(clientIDStr);
  const requestSwap = useCCSwapStore((s) => s.requestSwap);

  if (!eventID || !clientID) return null;

  const ccUrl = buildCCUrl(eventID);

  const handleClick = () => {
    if (needsSwap) {
      requestSwap(clientIDStr, clientName || `Client ${clientIDStr}`, ccUrl);
    } else {
      window.open(ccUrl, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Button
      size={size}
      variant="default"
      className="gap-1.5 btn-cc"
      onClick={handleClick}
    >
      <IdCardLanyard className="h-3.5 w-3.5" />
      {needsSwap ? 'Switch & Open in Control Center' : 'Open in Control Center'}
    </Button>
  );
}
